import "babel-polyfill";
import "es6-promise/auto";
import Vue from "vue";
import App from "./components/App.vue";
import router from "./router";
import store from "./store";
import NavSteps from "./components/NavSteps";
import DialogSaveAndExit from "./components/DialogSaveAndExit";
import ElementUI from "element-ui";
import vSelect from "vue-select";
import locale from "element-ui/lib/locale/lang/en";
import "./scss/index.scss";

const debug = process.env.debug === "true";
Vue.config.performance = debug;

// Add `finally()` to `Promise.prototype`
Promise.prototype.finally = function (onFinally) {
  return this.then(
    /* onFulfilled */
    (res) => Promise.resolve(onFinally()).then(() => res),
    /* onRejected */
    (err) =>
      Promise.resolve(onFinally()).then(() => {
        throw err;
      }),
  );
};

Vue.use(ElementUI, { locale });

vSelect.props.components.default = () => ({
  Deselect: {
    render: (createElement) =>
      createElement("i", {
        class: {
          "el-select__caret": true,
          "el-tag__close": true,
          "el-icon-close": true,
        },
      }),
  },
  OpenIndicator: {
    render: (createElement) => {
      const element = createElement("i", {
        class: {
          "el-select__caret": true,
          "el-input__icon": true,
          "el-icon-arrow-down": true,
        },
      });
      return element;
    },
  },
});

Vue.component("v-select", vSelect);
Vue.component("nav-steps", NavSteps);
Vue.component("dialog-save-and-exit", DialogSaveAndExit);
Vue.component("scope", {
  functional: true,
  props: ["tag"],
  render(h, { data, props }) {
    return h(props.tag, null, data.scopedSlots.default(data.attrs));
  },
});

new Vue({
  el: "#app",
  router,
  // provide the store using the "store" option.
  // this will inject the store instance to all child components.
  store,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/index.js